// extracted by mini-css-extract-plugin
export var searchHeader = "_2w-0";
export var searchHeaderDark = "_2w-1";